export const StatusTypes = {
  NEW: "new",
  INPROGRESS: "inprogress",
  COMPLETED: "result-generation-completed",
  FAILED: "execution-failed",
  EMPTY: "",
  DELETED_SUCCESS: "Delete Artefact Succeeded"
};

export const ExtractMetadataKey = {
  Title: "title",
  Description: "description",
  isactive: "isactive",
  financialYear: "financialYear",
  schema: "schema",
  survey: "survey"
};

export const EXTRACT_DETAIL_SELECTED_TAB = "eb-extract-detail-selected-tab";
